import React from 'react';

export default class TransactionZapCashIcon extends React.Component {
  render() {
    return (
      <svg height="100%" viewBox="0 0 32.047 19.327">
        <g>
          <path
            fill="#6FCBE9"
            d="M17.188,9.698V8.839c0-0.227-0.075-0.478-0.224-0.746c-0.156-0.282-0.367-0.538-0.627-0.762
          c-0.261-0.225-0.573-0.413-0.927-0.557c-0.346-0.141-0.702-0.213-1.056-0.214c-0.717,0.028-1.305,0.281-1.798,0.774
          c-0.495,0.495-0.763,1.09-0.819,1.818c0.001,0.136,0.011,0.271,0.03,0.404c0.001,0,0.001,0,0.001,0
          c0.035,0.236,0.098,0.466,0.191,0.689c0.147,0.354,0.356,0.673,0.621,0.95c0.264,0.275,0.571,0.492,0.912,0.645
          c0.338,0.151,0.699,0.228,1.071,0.228c0.68,0,1.764-0.37,2.626-1.404c0,0-0.001-0.677-0.002-0.953
          C17.188,9.705,17.188,9.698,17.188,9.698z"
          />
          <path
            fill="#6FCBE9"
            d="M25.304,7.901c-0.233-0.388-0.544-0.699-0.923-0.922c-0.379-0.224-0.81-0.351-1.282-0.378
          c-0.354,0.001-0.705,0.074-1.044,0.216c-0.351,0.147-0.668,0.34-0.943,0.574c-0.271,0.231-0.486,0.487-0.64,0.761
          c-0.146,0.26-0.22,0.507-0.22,0.733v0.422l0.002,1.538c0.656,0.673,1.701,1.325,2.612,1.28c0.573-0.027,1.027-0.155,1.43-0.405
          c0.438-0.271,0.789-0.635,1.043-1.082c0.251-0.441,0.379-0.921,0.381-1.426c-0.023-0.267-0.133-0.652-0.227-0.918
          C25.438,8.159,25.379,8.026,25.304,7.901z"
          />
          <path
            fill="#6FCBE9"
            d="M28.247,0H3.8C1.701,0,0,1.701,0,3.8v11.726c0,2.099,1.701,3.8,3.8,3.8h24.446c2.099,0,3.8-1.702,3.8-3.8
          V3.8C32.047,1.701,30.346,0,28.247,0z M11.302,13.029H4.453l3.016-4.142c0,0-0.001,0-0.002,0l1.525-2.095H4.741V5.586h6.65
          L8.78,9.161l0.001,0l-1.964,2.691h3.772c0.275,0.332,0.497,0.555,0.91,0.891c0.171,0.14,0.417,0.286,0.417,0.286H11.302z
           M18.382,12.915H17.19v-0.589c-0.355,0.259-0.726,0.478-1.042,0.611c-0.517,0.216-1.049,0.326-1.584,0.326
          c-0.721,0-1.399-0.191-2.015-0.568c-0.611-0.374-1.103-0.886-1.462-1.52c-0.304-0.539-0.48-1.125-0.526-1.744
          c-0.001,0-0.001,0-0.002,0c-0.008-0.11-0.014-0.22-0.014-0.332l0.001-0.021c0.047-0.67,0.242-1.291,0.577-1.848
          c0.337-0.559,0.79-1.011,1.346-1.342c0.558-0.332,1.177-0.511,1.84-0.532h0.01c0.685,0,1.348,0.165,1.971,0.491
          c0.623,0.326,1.129,0.76,1.506,1.29c0.387,0.544,0.583,1.117,0.583,1.704V9.64l0.002,0V12.915z M26.368,11.21
          c-0.36,0.637-0.852,1.15-1.461,1.524c-0.613,0.377-1.29,0.568-2.012,0.568c-0.354,0-0.706-0.048-1.045-0.14
          c-0.338-0.093-0.687-0.241-1.036-0.442c-0.188-0.108-0.378-0.232-0.559-0.364v3.816h-1.192V9.592c0,0-0.001,0-0.002,0V8.88
          c0-0.451,0.113-0.893,0.338-1.314c0.219-0.411,0.524-0.783,0.908-1.109c0.381-0.323,0.821-0.581,1.308-0.767
          c0.489-0.187,1.002-0.282,1.523-0.282h0.01c0.492,0.016,0.969,0.121,1.417,0.312c0.448,0.191,0.844,0.455,1.178,0.785
          c0.325,0.323,0.591,0.711,0.795,1.151c0.005-0.003,0.01-0.006,0.015-0.008c0.023,0.06,0.048,0.135,0.072,0.206
          c0.006,0.014,0.012,0.028,0.018,0.042c-0.001,0-0.002,0.001-0.003,0.001c0.127,0.383,0.252,0.873,0.274,1.214l0.001,0.02
          C26.912,9.873,26.729,10.573,26.368,11.21z M27.957,8.794c-0.005,0.077-0.068,0.136-0.143,0.136H27.81h-0.075h-0.004
          c-0.04,0-0.078-0.017-0.105-0.046c-0.027-0.03-0.041-0.069-0.038-0.109c0.006-0.101,0.01-0.185,0.01-0.266
          c0-0.352-0.047-0.692-0.132-1.018c-0.444-1.687-1.959-2.935-3.759-2.935c-0.079,0-0.143-0.065-0.143-0.145v-0.08
          c0-0.081,0.064-0.146,0.143-0.146c2.128,0,3.891,1.592,4.206,3.663c0.001,0.01,0.003,0.019,0.004,0.028
          c0.03,0.207,0.051,0.417,0.051,0.632C27.967,8.595,27.964,8.686,27.957,8.794z M28.977,8.794c-0.005,0.103-0.089,0.184-0.191,0.184
          h-0.004h-0.075h-0.004c-0.052,0-0.102-0.022-0.139-0.06c-0.036-0.039-0.055-0.091-0.052-0.143c0.005-0.091,0.007-0.18,0.007-0.265
          c0-0.298-0.027-0.59-0.077-0.873l0-0.001c-0.023-0.131-0.053-0.258-0.086-0.385c-0.004-0.017-0.008-0.034-0.013-0.051
          c-0.033-0.121-0.072-0.24-0.114-0.357c-0.673-1.876-2.444-3.221-4.523-3.221c-0.106,0-0.191-0.087-0.191-0.194V3.348
          c0-0.107,0.085-0.194,0.191-0.194c2.91,0,5.278,2.402,5.278,5.355C28.984,8.6,28.982,8.696,28.977,8.794z"
          />
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/TransactionZapCardIcon.js